import type { TrendStatus } from '@ongrid/shared';

interface FilterBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  trendStatus: TrendStatus | null;
  onTrendStatusChange: (value: TrendStatus | null) => void;
  onRefresh: () => void;
}

const trendOptions: (TrendStatus | 'All')[] = [
  'All',
  'New & Growing',
  'Growing',
  'Stable',
  'Stagnant',
  'Decaying',
  'New',
];

export function FilterBar({
  search,
  onSearchChange,
  trendStatus,
  onTrendStatusChange,
  onRefresh,
}: FilterBarProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between mb-6">
      <div className="flex flex-col sm:flex-row gap-3 flex-1">
        {/* Search input */}
        <div className="relative">
          <input
            type="text"
            placeholder="Search pages..."
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className="bg-[var(--bg-tertiary)] border border-[var(--border-color)] rounded-lg px-4 py-2 pl-10 text-sm text-[var(--text-primary)] placeholder-[var(--text-muted)] focus:outline-none focus:border-brand-500 w-full sm:w-64"
          />
          <svg
            className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--text-muted)]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>

        {/* Trend filter */}
        <select
          value={trendStatus ?? 'All'}
          onChange={(e) =>
            onTrendStatusChange(e.target.value === 'All' ? null : (e.target.value as TrendStatus))
          }
          className="bg-[var(--bg-tertiary)] border border-[var(--border-color)] rounded-lg px-4 py-2 text-sm text-[var(--text-primary)] focus:outline-none focus:border-brand-500"
        >
          {trendOptions.map((option) => (
            <option key={option} value={option}>
              {option === 'All' ? 'All Trends' : option}
            </option>
          ))}
        </select>
      </div>

      {/* Refresh button */}
      <button
        onClick={onRefresh}
        className="flex items-center gap-2 bg-brand-500 hover:bg-brand-600 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
        Refresh
      </button>
    </div>
  );
}

